import deviceConfigurations from '../service/deviceConfigurations'
const state = {
  deviceConfigurations :{}
}

const actions = {
    getDeviceConfigurations({ commit }) {
        return deviceConfigurations.getConfigurations().then(configurations =>
        commit('setDeviceConfigurations',configurations))
    },
   
}
const mutations = {
    setDeviceConfigurations(state,configurations){
        state.configurations= configurations
    },
   
}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



